<template>
  <div class="border p-4 rounded-lg">
    <h3 class="text-lg font-bold">{{ drawingPackage.name }}</h3>
    <p>{{ drawingPackage.description }}</p>
    <p class="text-xl font-bold">{{ drawingPackage.price }} {{ t('message.currency') }}</p>
    <p>{{ drawingPackage.drawings_amount }} {{ t('message.drawings') }}</p>
    <button @click="$emit('purchase', drawingPackage.id)" class="bg-blue-500 text-white p-2 rounded-md mt-4">{{ t('message.buyPackage') }}</button>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps({
  drawingPackage: Object,
});
</script>
